import { useNavigate } from '@thd-olt-component-react/router';
import { updateQueryParams } from '../product-results-helpers';

// NOTE: During harmony-prerender (SSR for docs/build), router context may be absent.
// Calling useNavigate() without a provider throws an invariant. We defensively
// provide a no-op navigate in that case so build does not fail.
export function useSafeNavigate() {
  try {
    // try to get navigate hook normally
    return useNavigate();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[product-results] Falling back to no-op navigate during prerender.');
    return () => {};
  }
}

export function ProductResultsSearchMethodsPLP() {
  const navigate = useSafeNavigate();

  const onDimensionsChangePLP = ({ refinement, viewPrimaryFilters }) => {
    if (!viewPrimaryFilters) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('filters-refinements.click', refinement);
    }
    navigate(refinement?.url);
  };

  const onFulfillmentChangePLP = ({ refinement }) => {

    navigate(refinement.url);
  };

  const onSortChangePLP = ({
    sortby, sortorder, name, currentPage, page, updatedPath = null, path
  }) => {
    const newPath = updateQueryParams(updatedPath || path, [
      {
        paramName: 'Nao',
        paramValue: null
      },
      {
        paramName: 'sortorder',
        paramValue: sortorder
      },
      {
        paramName: 'sortby',
        paramValue: sortby
      }
    ]);
    window.LIFE_CYCLE_EVENT_BUS.trigger('sort-refinements.click', {
      name,
      currentPage,
      page
    });
    navigate(newPath);
  };

  const onPageChangePLP = ({ url, resultsDimensionsRef }) => {
    navigate(url);

    const currentElement = resultsDimensionsRef?.current;
    const slotsContainerElement = currentElement?.parentElement?.parentElement?.parentElement;
    const offsetTop = slotsContainerElement?.offsetTop;

    window.scrollTo({
      top: offsetTop || 0,
      left: 0,
      behavior: 'smooth'
    });
  };

  return {
    onDimensionsChangePLP,
    onSortChangePLP,
    onPageChangePLP,
    onFulfillmentChangePLP
  };
}